import { Link } from "react-router-dom";
import { TableContainer } from "./styles";
import { ReactSVG } from "react-svg";
import ativo from "../../../assets/ativo.svg";
import inativo from "../../../assets/inativo.svg";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import { toast } from "react-toastify";

const Table = ({ statusSelecionado, textoPesquisa }) => {
  const [substrato, setSubstrato] = useState([]);

  function buscarSubstrato() {
    api.get("/substrato")
      .then((response) => {
        setSubstrato(response.data.data.substratos);
      })
      .catch((error) => {
        console.error("Erro ao buscar dados da API:", error);
        toast.error("Erro ao buscar dados");
      });
  }
  useEffect(() => {
    buscarSubstrato();
  }, []);

  const colunas = ["Id", "Nome", "Gramatura/Espessura", "Data de cadastro", "Data de atualização", "Status"];
  const filtrarCategoria = (categoria) => {
    const perfilFiltrado =
      !statusSelecionado || categoria.status == parseInt(statusSelecionado);
    const pesquisaFiltrada =
      !textoPesquisa ||
      categoria.nome.toLowerCase().includes(textoPesquisa.toLowerCase());

    const idCategoria = parseInt(textoPesquisa);
    const idFiltrado = !isNaN(idCategoria) && categoria.id === idCategoria;

    return perfilFiltrado && (pesquisaFiltrada || idFiltrado);
  };

  const substratoFiltrados = substrato.filter(filtrarCategoria);

  return (
    <TableContainer>
      <table>
        <thead>
          <tr>
            {colunas.map((coluna) => (
              <th key={coluna}>{coluna}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {substratoFiltrados.map((substrato) => (
            <tr className="map" key={substrato.id}>
              <td>#{substrato.id}</td>
              <td>{substrato.nome}</td>
              <td>{substrato.gramatura_espessura}</td>
              <td>{substrato.data_criacao}</td>
              <td>{substrato.data_atualizacao}</td>
              {substrato.status == 1 ? (
                <td>
                  <div className="ativo">
                    <ReactSVG src={ativo} />
                    <p>ativo</p>
                  </div>
                </td>
              ) : (
                <td>
                  <div className="ativo">
                    <ReactSVG src={inativo} />
                    <p>inativo</p>
                  </div>
                </td>
              )}

              <td className="td-editar">
                <Link
                  to={`/substrato/editar/${substrato.id}`}
                  className="editar"
                  htmlFor="editar"
                >
                  Abrir
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableContainer>
  );
};

export default Table;
